export enum UserRole {
  Staff = 'staff',
  Organizer = 'organizer',
  Kiosk = 'kiosk_anonymous',
  CheckManager = 'checkin_manager',
  LeadCaptureStaff = 'lead_capture_staff',
}

export enum VerifyType {
  Email = 'verify_email',
  Password = 'verify_password',
  OneTimeCode = 'verify_one_time_code',
}

export type UserSession = {
  userId: string;
  userRole: UserRole;
  firstName: string;
  eventId?: string;
  companyId?: string;
  peopleId?: string;
  email?: string;
  result?: VerifyType;
};
